import styled from 'styled-components';

import {
  font16,
  font20,
  font24,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import { spacing4, spacing12 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import { grey10 } from 'approot/shared/styles/colours.style';

type SuggestedAnswerTitleProps = {
  $isSmall?: boolean;
  $isLarge?: boolean;
};
export const SuggestedAnswerTitleRichtextOverride = styled.div<SuggestedAnswerTitleProps>`
  display: inline-flex;
  gap: ${rem(spacing4)};
  font-weight: ${fontWeightMedium};
  margin-bottom: ${rem(spacing12)};
  text-align: left !important;

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${grey10};
    font-weight: ${fontWeightMedium};
    ${({ $isSmall, $isLarge }) =>
      $isLarge ? font24 : $isSmall ? font16 : font20};
  }

  p {
    text-align: left !important;
    margin-bottom: 0;
  }
`;
